import { ofType } from 'redux-observable';

import { ajax } from 'rxjs/ajax';

import { of } from 'rxjs';

import { map, switchMap, catchError } from 'rxjs/operators';

import {
  RESET_ACCOUNT_PASSWORD,
  RESET_ACCOUNT_PASSWORD_SUCCESS,
  RESET_ACCOUNT_PASSWORD_FAILED,
} from '../../constants';

const resetPassword = (action$, state$) =>
  action$.pipe(
    ofType(RESET_ACCOUNT_PASSWORD),
    switchMap(action =>
      ajax({
        url: `${state$.value.auth.server}/password-reset/${action.token}?v=${process.env.REACT_APP_VERSION}`,
        responseType: 'json',
        crossDomain: true,
        body: JSON.stringify(action.payload),
        method: 'POST',
      }).pipe(
        map(response => {
          return {
            type: RESET_ACCOUNT_PASSWORD_SUCCESS,
            data: response.response,
          };
        }),
        catchError(error =>
          of({
            type: RESET_ACCOUNT_PASSWORD_FAILED,
            error,
          })
        )
      )
    )
  );

export default resetPassword;
